
<div class="location-unit">
    <c-tag
        :label           = "contract"
        :active          = "false"
        background-color = "primary"
    />

    <div
        class="location-unit-elevator-no"
        :class="active ? 'black--text' : 'lightgray'"
    >
        {{ unit.elevatorNo }}
    </div>

    <div
        class="location-unit-elevator-no black--text"
    >
        {{ unit.technicianName }}
    </div>
</div>
